import { FaBars, useState, useRef, useLocation, Link, sidebarLogo, Dashboard, Category, Products, Orders, Distributor, customer, Users, Reports, Accounts, Settings, Help, Documentation, noUser, BsArrowLeftCircleFill, FaAngleDown, FaUser, useEffect, FaFolder, FaCog, FaQuestionCircle, FaSignOutAlt } from '../../common/common';
import { Capitalize } from '../../common/CommonFunctions';
import './sidebar.css';
import { useNavigate } from 'react-router-dom';
import { StartLoading, StopLoading } from '../../Utils/loadingUtils';
import { showToast } from '../../Utils/toastUtils';
import axiosJWT from '../../secureAPI/axiosJWT';
const Sidebar = (props) => {



    console.log({ props: props });
    const navigate = useNavigate();
    const location = useLocation();
    const userTypes = props.UserTypeData;
    const userName = props.userName;
    const currentPlan = props.currentplan;
    const ActiveUser = props.ActiveUser;
    // console.log('currentPlan' + currentPlan);
    const profilePic = props.profilePic;
    const appID = props.appID;
    const currentUserType = props.currentUserType;
    // console.log("currentUserType" + currentUserType);
    const avatarUrl = useRef('/assets/images/noPreview.png');
    const [profilepic, setProfilepic] = useState(`${process.env.REACT_APP_API_URL}/assets/images/noUser.png`);
    const usertypeArray = typeof userTypes === 'string' ? userTypes.split(',').map(str => parseInt(str.trim())).filter(num => !isNaN(num)) : [];
    const hasOne = usertypeArray.includes(1);
    const hasTwo = usertypeArray.includes(2);
    const [isMenuClicked, setIsMenuClicked] = useState(false);
    const [menu_class, setMenuClass] = useState("menu hidden lg:block");
    const [isOpen, setIsOpen] = useState(false);
    const [isLoading, setisLoading] = useState(true);
    const [isDisabled, setisDisabled] = useState(false);
    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };
    useEffect(() => {
        showToast('', '');
        const defaultPic = noUser; // or `${process.env.REACT_APP_API_URL}/assets/images/noUser.png`
        if (props.profilePic !== '' && props.profilePic !== 'N/A') {
            // Determine the new profile picture URL
            const newProfilePic = props.profilePic
                ? `${process.env.REACT_APP_API_URL}/api/user/uploads/${props.profilePic}`
                : defaultPic;

            // Only update state if the value has actually changed
            if (profilepic !== newProfilePic) {
                setProfilepic(newProfilePic);
            }
        }
        else {
            setProfilepic(noUser);
        }

    }, [props.profilePic]);
    // Only depend on props.profilePic
    //  useEffect(() => {
    //             if (CompanyLogo !== '' && CompanyLogo !== undefined ) {
    //                 console.log('CompanyLogo' + CompanyLogo);
    //                 setcompanyLogo(`${process.env.REACT_APP_API_URL}/api/user/uploads/${CompanyLogo}`);
    //             }
    //             else {
    //                 setcompanyLogo(noUser);
    //             }
    //     }, [companyLogo]); 
    const logout = () => {
        // 1. Clear cookies for main domain AND subdomains
        const clearCookie = (name) => {
            // Clear for current subdomain (b2b.selzor.com)
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=b2b.selzor.com`;

            // Clear for root domain (selzor.com) to cover all subdomains
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.selzor.com`;
        };

        // 2. Clear all auth-related cookies
        clearCookie('accessToken');
        clearCookie('refreshToken');

        // 3. Clear localStorage/sessionStorage (if used)
        localStorage.clear();
        sessionStorage.clear();

        // 4. Verify cookies are gone (optional)
        const cookiesCleared = !document.cookie.match(/accessToken|refreshToken/);
        // console.log("Cookies cleared?", cookiesCleared); // Debug check

        // 5. Redirect to login WITH history replacement
        navigate('/', { replace: true });

        // 6. Force reload to prevent back-button issues
        window.location.reload();
    };
    const updateMenu = () => {
        if (!isMenuClicked) {
            // setBurgerClass("burger-bar clicked");
            setMenuClass("main-sidebar block ");
            // setBurgerMainClass("burger-menu-active");
            // setNaviClass("navi-active");
            // setBackLabel("visible");
        }
        else {
            // setBurgerClass("burger-bar unclicked");
            setMenuClass("main-sidebar hidden lg:block");
            // setBurgerMainClass("burger-menu");
            // setNaviClass("navi");
            // setBackLabel("hidden");
        }
        setIsMenuClicked(!isMenuClicked);
    }
    const menuItems = [
        {
            path: `/dashboard/${currentUserType}`,
            name: "Control",
            buyer: 1,
            seller: 1,
            icon: Dashboard,
            clasess:
                "bg-[#eaaf00] text-black p-[15px] rounded-md mt-[20px] font-semibold tooltip left-[18%] top-[65px]",
        },
        {
            path: "/seller/categories/View-categories/",
            name: "categories",
            buyer: 0,
            seller: 1,
            icon: Category,
            clasess:
                "bg-[#eaaf00] text-black p-[15px] rounded-md mt-[20px] font-semibold tooltip left-[18%] top-[115px]",
        },
        {
            path: "/seller/products/View-all-products/",
            name: "Catalogue",
            buyer: 0,
            seller: 1,
            icon: Products,
            clasess:
                " bg-[#eaaf00] text-black p-[15px] rounded-md mt-[20px]  font-semibold tooltip left-[18%] top-[175px] ",
        },
        {
            path: "/buyer/suppliers/View-all-suppliers/",
            name: "Suppliers",
            buyer: 1,
            seller: 0,
            icon: Distributor,
            clasess:
                " bg-[#eaaf00] text-black p-[15px] rounded-md mt-[20px]  font-semibold tooltip left-[18%] top-[117px] ",
        },
        {
            path: "/buyer/orders/View-Buyer-orders/",
            name: "orders",
            buyer: 1,
            seller: 0,
            icon: Orders,
            clasess:
                " bg-[#eaaf00] text-black p-[15px] rounded-md mt-[20px] font-semibold tooltip left-[18%] top-[175px] ",
        },
        {
            path: "/seller/orders/View-Seller-orders/Placed",
            name: "orders",
            buyer: 0,
            seller: 1,
            icon: Orders,
            clasess:
                " bg-[#eaaf00] text-black p-[15px] rounded-md mt-[20px] font-semibold tooltip left-[18%] top-[232px] ",
        },
        {
            path: "/seller/distributors/View-distributor/",
            name: "distributors",
            buyer: 0,
            seller: 1,
            icon: Distributor,
            clasess:
                " bg-[#eaaf00] text-black p-[15px] rounded-md mt-[20px]  font-semibold tooltip left-[18%] top-[295px] ",
        },
        {
            path: "/seller/buyer/View-buyers/",
            name: "Buyers",
            buyer: 0,
            seller: 1,
            icon: customer,
            clasess:
                " bg-[#eaaf00] text-black p-[15px] rounded-md mt-[20px]  font-semibold tooltip left-[18%] top-[353px] ",
        },
        ...(currentPlan > 0
            ? [{
                path: "/seller/users/View-Users/",
                name: "users",
                buyer: 0,
                seller: 1,
                icon: Users,
                clasess: "bg-[#eaaf00] text-black p-[15px] rounded-md mt-[20px] font-semibold tooltip left-[18%] top-[410px]",
            }]
            : []),
        // {
        //     path: "/seller/users/View-Users/",
        //     name: "users",
        //     buyer: 0,
        //     seller: 1,
        //     icon: Users,
        //     clasess:
        //         " bg-[#eaaf00] text-black p-[15px] rounded-md mt-[20px]  font-semibold tooltip left-[18%] top-[410px] ",//410px
        // },
        {
            path: "/seller/reports/",
            name: "reports",
            buyer: 0,
            seller: 1,
            icon: Reports,
            clasess: `bg-[#eaaf00] text-black p-[15px] rounded-md mt-[20px] font-semibold tooltip left-[18%] ${currentPlan > 0 ? 'top-[470px]' : 'top-[410px]'}`,
        },
        {
            path: "/buyer/reports/",
            name: "reports",
            buyer: 1,
            seller: 0,
            icon: Reports,
            clasess:
                " bg-[#eaaf00] text-black p-[15px] rounded-md mt-[20px]  font-semibold tooltip left-[18%] top-[235px] ",//525px
        },
        {
            path: "/seller/profile/",
            name: "account",
            buyer: 0,
            seller: 1,
            icon: Accounts,
            clasess: `bg-[#eaaf00] text-black p-[15px] rounded-md mt-[20px] font-semibold tooltip left-[18%] ${currentPlan > 0 ? 'top-[525px]' : 'top-[470px]'}`,

        },
        {
            path: "/buyer/profile/",
            name: "account",
            buyer: 1,
            seller: 0,
            icon: Accounts,
            clasess: " bg-[#eaaf00] text-black p-[15px] rounded-md mt-[20px] font-semibold tooltip left-[18%] top-[295px] ",//585px

        },
        {
            path: "/seller/Settings/",
            name: "Rules",
            buyer: 0,
            seller: 1,
            icon: Settings,
            clasess: `bg-[#eaaf00] text-black p-[15px] rounded-md mt-[20px] font-semibold tooltip left-[18%] ${currentPlan > 0 ? 'top-[585px]' : 'top-[530px]'}`,
        },
        {
            path: "/buyer/Settings/",
            name: "settings",
            buyer: 1,
            seller: 0,
            icon: Settings,
            clasess:
                " bg-[#eaaf00] text-black p-[15px] rounded-md mt-[20px] font-semibold tooltip left-[18%] top-[355px] ",
        }


    ]

    const DashboardPagevalidPaths = ["/dashboard/seller", "/dashboard/buyer"];
    const CategoryPagevalidPaths = [
        "/seller/categories/View-categories/",
        "/seller/categories/Add-category/",
    ];
    const ProductsPagevalidPaths = [
        "/seller/products/View-all-products/",
        "/seller/products/Add-product/",
        "/seller/products/AddProductPriceList/",
        "/seller/products/ProductPriceList/",
        "/seller/products/view-product-details/",
    ];
    const SuppliersPagevalidPaths = [
        "/buyer/supplier/View-all-suppliers/",
        "/buyer/supplier/Add-supplier/",
        "/buyer/suppliers/supplier-products/",
    ];
    const DistributorsPagevalidPaths = [
        "/seller/distributors/View-distributor/",
        "/seller/distributors/View-distributors-request/",
        "/seller/distributors/Add-distributor/",
    ];
    const BuyersPagevalidPaths = [
        "/seller/buyer/View-buyers/",
    ];
    const OrdersPagevalidPaths = [
        "/buyer/orders/View-Buyer-orders/",
        "/buyer/orders/Order-details/",
    ];
    const OrdersSellerPagevalidPaths = [
        "/seller/orders/View-Seller-orders/Placed",
        "/seller/orders/Seller-Order-details/",
    ];
    const UsersPagevalidPaths = [
        "/seller/users/Add-User/",
        "/seller/users/View-Users/",
    ];
    const SettingsPagevalidPaths = [
        "/seller/Settings/",
        "/buyer/Settings/",
        "/seller/GeneralSettings/",
    ];
    const ReportsPagevalidPaths = [
        "/seller/reports/",
        "/buyer/reports/",
    ];

    const PlanPagevalidPaths = ["/seller/plans/",];


    const isDahboardPathExistPage = DashboardPagevalidPaths.includes(location.pathname) || location.pathname.includes("/dashbaord/seller") || location.pathname.includes("/dashbaord/buyer");
    const isCategoryPathExistPage = CategoryPagevalidPaths.includes(location.pathname) || location.pathname.includes("/seller/categories/View-categories/") || location.pathname.includes("/seller/categories/Add-category/");
    const isProductsPathExistPage = ProductsPagevalidPaths.includes(location.pathname) || location.pathname.includes("/seller/products/View-all-products/") || location.pathname.includes("/seller/products/Add-product/") || location.pathname.includes("/seller/products/AddProductPriceList/") || location.pathname.includes("/seller/products/ProductPriceList/") || location.pathname.includes("/seller/products/view-product-details/");
    const isProductseditPathExistPage = ProductsPagevalidPaths.includes(location.pathname) || location.pathname.includes("seller/products/edit-product/");
    const isSupplierPathExistPage = SuppliersPagevalidPaths.includes(location.pathname) || location.pathname.includes("/buyer/suppliers/View-all-suppliers/") || location.pathname.includes("/buyer/suppliers/Add-supplier/") || location.pathname.includes("/buyer/suppliers/supplier-products/");
    const isdistributorsPathExistPage = DistributorsPagevalidPaths.includes(location.pathname) || location.pathname.includes("/seller/distributors/View-distributor/") || location.pathname.includes("/seller/distributors/View-distributors-request/");
    const isbuyersPathExistPage = BuyersPagevalidPaths.includes(location.pathname) || location.pathname.includes("/seller/buyer/View-buyers/");
    const isOrdersPathExistPage = OrdersPagevalidPaths.includes(location.pathname) || location.pathname.includes("/buyer/orders/View-Buyer-orders/") || location.pathname.includes("/buyer/orders/Order-details/");
    const isSellerOrdersPathExistPage = OrdersSellerPagevalidPaths.includes(location.pathname) || location.pathname.includes("seller/orders/View-Seller-orders/Placed") || location.pathname.includes("/seller/orders/Order-details");
    const isUsersPathExistPage = UsersPagevalidPaths.includes(location.pathname) || location.pathname.includes("/seller/users/Add-User/") || location.pathname.includes("/seller/users/View-Users/");
    const isPlanPathExistPage = PlanPagevalidPaths.includes(location.pathname) || location.pathname.includes("/seller/plans/");
    const isSettingsPathExistPage = SettingsPagevalidPaths.includes(location.pathname) || location.pathname.includes("/seller/profile/") || location.pathname.includes("/seller/EditProductAttributes/") || location.pathname.includes("/seller/Badges/") || location.pathname.includes("/seller/Warehouse/") || location.pathname.includes("/buyer/Settings/")
        || location.pathname.includes("/buyer/profile/");
    const isReportsPathExistPage = ReportsPagevalidPaths.includes(location.pathname) || location.pathname.includes("/seller/reports/");
    // const isProfilePathExistPage = ProfilePagevalidPaths.includes(location.pathname) || location.pathname.includes("/seller/profile/");




    return (
        <div>
            <button className=" absolute left-2 top-4 p-2 bg-blue-500 text-white rounded md:hidden" onClick={updateMenu} > <FaBars />  </button>
            <div className={`${props.issidebarOpen ? " w-[100%] md:w-1/5 duration-200" : "w-20 duration-200"} ${menu_class} lg:fixed z-10 fixed left-0 top-0 main-sidebar mobilesidebar`}>
                <div className="h-screen flex flex-row justify-between">
                    <div className={`${((hasOne && hasTwo) && currentUserType.toLowerCase() === 'seller') ? '!bg-primary' : ((hasOne || (hasOne && hasTwo)) && currentUserType.toLowerCase() === 'buyer') ? 'bg-gradient-to-b from-secondarygradiant to-secondarygradiant' : ((hasOne) && (currentUserType.toLowerCase() === 'seller' || currentUserType.toLowerCase() === 'buyer')) ? 'bg-gradient-to-b from-secondarygradiant to-secondarygradiant' : null} flex flex-col justify-between items-center w-20  overflow-y-auto`}>
                        <div className="flex flex-col space-y-4">
                            <Link to={`/dashboard/${currentUserType}`} className='m-auto'>
                                <img src={sidebarLogo} alt="Selzor Logo" width={50} className='' />
                            </Link>
                            <aside className="sidebar">
                                <nav className="nav flex flex-col justify-between" role="navigation">
                                    {menuItems.map((item, index) => {
                                        // const a = ( item.seller === 1 && currentUserType.toLowerCase() === 'seller');
                                        // const b = ( item.buyer === 1 && currentUserType.toLowerCase() === 'buyer');
                                        // console.log(Capitalize(item.name));
                                        // console.log( 'a' + a + '/ b ' + b);
                                        // if ((hasOne && hasTwo) && item.seller === 1 && currentUserType.toLowerCase() === 'seller') { // 
                                        if (hasTwo && item.seller === 1 && currentUserType.toLowerCase() === 'seller') { // seller Menu
                                            return (<Link to={item.path} key={index} className="nav-logo-icons nav-logo grid p-[0.9rem]">

                                                <img className="nav-logo-icon cursor-pointer" height={30} width={30} src={item.icon} alt={item.name} />
                                                <div className={item.clasess}>{Capitalize(item.name)}</div>
                                            </Link>)
                                        }
                                        else if (hasOne && item.buyer === 1 && currentUserType.toLowerCase() === 'buyer') // Buyer Menu
                                        {
                                            return (<Link to={item.path} key={index} className="nav-logo-icons nav-logo grid p-[0.9rem]">
                                                <img className="nav-logo-icon cursor-pointer" height={30} width={30} src={item.icon} alt={item.name} />
                                                <div className={item.clasess}>{Capitalize(item.name)}</div>
                                            </Link>)
                                        }
                                        // else if ((item.buyer === 1 && item.seller === 0 ) && (currentUserType.toLowerCase() === 'buyer' || currentUserType.toLowerCase() === 'seller')) // Buyer Menu
                                        // {

                                        //     return (<Link to={item.path} key={index} className="nav-logo-icons nav-logo grid p-[0.9rem]">
                                        //         <img className="nav-logo-icon cursor-pointer" height={30} width={30} src={item.icon} alt={item.name} />
                                        //         <div className={item.clasess}>{Capitalize(item.name)}</div>
                                        //     </Link>)
                                        // }
                                    }
                                    )}
                                </nav>
                            </aside>
                        </div>
                        <div className="flex flex-col space-y-4">
                            <Link to="#" className="nav-logo grid p-[0.9rem]">
                                <img className="nav-logo-icon cursor-pointer" height={30} width={30} src={Help} alt="Help" />
                            </Link>
                            <Link to="#" className="nav-logo grid p-[0.9rem]">
                                <img className="nav-logo-icon cursor-pointer" height={30} width={30} src={Documentation} alt="Documentation" />
                            </Link>
                        </div>
                    </div>

                    <div className={`${props.issidebarOpen ? "duration-1000" : "hidden"} bg-[#ededed] flex flex-col flex-1 overflow-x-hidden h-screen z-0 pt-1`}>
                        <Link to="#">
                            <div className="flex items-start border-b pb-2 bg-white rounded-lg p-2 m-2">

                                <div className="w-[20%] flex justify-center relative">
                                    <div className="relative">
                                        <img
                                            src={profilepic || noUser}
                                            alt="Avatar"
                                            className="w-[50px] lg:w-[100px] rounded-full border-white border-2"
                                        />

                                    </div>
                                </div>


                                <div className="w-[80%] p-2 relative">
                                    <div
                                        className="flex justify-between items-center cursor-pointer"
                                        onClick={toggleDropdown}
                                    >
                                        <div>
                                            <h6 className="font-semibold text-md capitalize">{userName}</h6>
                                            <p className="text-sm text-gray-600">APP ID: {appID}</p>
                                        </div>
                                        <div>
                                            <FaAngleDown
                                                className={`mr-3 text-[#216ef5] transition-transform duration-200 ${isOpen ? 'rotate-180' : ''
                                                    }`}
                                            />
                                        </div>
                                    </div>

                                    {/* Dropdown Menu */}
                                    {isOpen && (
                                        <div className="absolute right-[-10px] mt-4  w-72 bg-white rounded-md shadow-lg py-1 z-50">
                                            <Link
                                                to="/seller/profile/"
                                                className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                            >
                                                <FaUser className="mr-3" /> Profile
                                            </Link>

                                            <Link
                                                to="/seller/Settings/"
                                                className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                            >
                                                <FaCog className="mr-3" /> Rules
                                            </Link>

                                            <Link
                                                to="#"
                                                className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                            >
                                                <FaQuestionCircle className="mr-3" /> Help
                                            </Link>

                                            <button
                                                onClick={logout}
                                                className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                            >
                                                <FaSignOutAlt className="mr-3" /> Log Out
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </Link>

                        <div>
                            {isDahboardPathExistPage && (
                                <h6 className="bg-white m-2 mt-[5px] rounded-md py-3.5 px-2 font-semibold ">Control</h6>
                            )}
                            {isCategoryPathExistPage && (
                                <>
                                    <h6 className="bg-white mt-[5px] rounded-md py-3.5 px-2 m-2 font-semibold">Categories</h6>
                                    <Link to="/seller/categories/View-categories/" >
                                        <div className="m-2 px-3 bg-white rounded-md ">
                                            <div className="flex-auto overflow-y-auto ">
                                                <div className="border-b-[1px] border-[#EBEBEB] pb-1 pt-2 ">
                                                    <div className="flex flex-row justify-between items-center space-x-2 ">
                                                        <strong className=" flex-grow text-sm font-bold text-[#002080]">
                                                            View All Category
                                                        </strong>
                                                    </div>
                                                    <div className="flex flex-row justify-between items-center space-x-2">
                                                        <p className=" mr-8 flex-grow text-sm">
                                                            All currently available orders will be viewed here
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>

                                    {ActiveUser === 1 &&
                                        <Link to="/seller/categories/Add-category/">
                                            <div className="m-2 px-3 bg-white rounded-md ">
                                                <div className="flex-auto overflow-y-auto ">
                                                    <div className="border-b-[1px] border-[#EBEBEB] pb-1 pt-2 ">

                                                        <div className="flex flex-row justify-between items-center space-x-2 ">
                                                            <strong className=" flex-grow text-sm font-bold text-[#002080]">
                                                                Add New Category
                                                            </strong>
                                                        </div>
                                                        <div className="flex flex-row justify-between items-center space-x-2">
                                                            <p className=" mr-8 flex-grow text-sm">
                                                                All currently available orders will be viewed here
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    }

                                </>
                            )}

                            {(isProductsPathExistPage || isProductseditPathExistPage) && (
                                <>
                                    <h6 className="bg-white mt-[5px] rounded-md py-3.5 px-2 m-2 font-semibold">Catalogue</h6>
                                    <Link to="/seller/products/View-all-products/">
                                        <div className="m-2 px-3 bg-white rounded-md ">
                                            <div className="flex-auto overflow-y-auto ">
                                                <div className="border-b-[1px] border-[#EBEBEB] pb-1 pt-2 ">
                                                    <div className="flex flex-row justify-between items-center space-x-2 ">
                                                        <strong className=" flex-grow text-sm font-bold text-[#002080]">
                                                            View All Catalogue
                                                        </strong>
                                                    </div>
                                                    <div className="flex flex-row justify-between items-center space-x-2">
                                                        <p className=" mr-8 flex-grow text-sm">
                                                            All currently available orders will be viewed here
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>

                                    {ActiveUser === 1 &&
                                        <Link to="/seller/products/Add-product/">
                                            <div className="m-2 px-3 bg-white rounded-md">
                                                <div className="flex-auto overflow-y-auto ">
                                                    <div className="border-b-[1px] border-[#EBEBEB] pb-1 pt-2 ">
                                                        <div className="flex flex-row justify-between items-center space-x-2 ">
                                                            <strong className=" flex-grow text-sm font-bold text-[#002080]">
                                                                Add New Product
                                                            </strong>
                                                        </div>
                                                        <div className="flex flex-row justify-between items-center space-x-2">
                                                            <p className=" mr-8 flex-grow text-sm">
                                                                All currently available orders will be viewed here
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    }

                                    {ActiveUser === 1 &&
                                        <Link to="/seller/products/AddProductPriceList/">
                                            <div className="m-2 px-3 bg-white rounded-md">
                                                <div className="flex-auto overflow-y-auto ">
                                                    <div className="border-b-[1px] border-[#EBEBEB] pb-1 pt-2 ">
                                                        <div className="flex flex-row justify-between items-center space-x-2 ">
                                                            <strong className=" flex-grow text-sm font-bold text-[#002080]">
                                                                Add Custom PriceList
                                                            </strong>
                                                        </div>
                                                        <div className="flex flex-row justify-between items-center space-x-2">
                                                            <p className=" mr-8 flex-grow text-sm">
                                                                All currently available orders will be viewed here
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    }
                                </>
                            )}
                            {isSupplierPathExistPage && (
                                <>
                                    <h6 className="bg-white mt-[5px] rounded-md py-3.5 px-2 m-2 font-semibold">Supplier</h6>
                                    <Link to="/buyer/suppliers/View-all-suppliers/">
                                        <div className="m-2 px-3 bg-white rounded-md ">
                                            <div className="flex-auto overflow-y-auto ">
                                                <div className="border-b-[1px] border-[#EBEBEB] pb-1 pt-2 ">
                                                    <div className="flex flex-row justify-between items-center space-x-2 ">
                                                        <strong className=" flex-grow text-sm font-bold text-[#002080]">
                                                            View All Suppliers
                                                        </strong>
                                                    </div>
                                                    <div className="flex flex-row justify-between items-center space-x-2">
                                                        <p className=" mr-8 flex-grow text-sm">
                                                            All currently available orders will be viewed here
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>

                                    {/* {ActiveUser === 1 && */}
                                    <Link to="/buyer/suppliers/Add-supplier/">
                                        <div className="m-2 px-3 bg-white rounded-md ">
                                            <div className="flex-auto overflow-y-auto ">
                                                <div className="border-b-[1px] border-[#EBEBEB] pb-1 pt-2 ">
                                                    <div className="flex flex-row justify-between items-center space-x-2 ">
                                                        <strong className=" flex-grow text-sm font-bold text-[#002080]">
                                                            Add New Supplier
                                                        </strong>
                                                    </div>
                                                    <div className="flex flex-row justify-between items-center space-x-2">
                                                        <p className=" mr-8 flex-grow text-sm">
                                                            All currently available orders will be viewed here
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                    {/* } */}
                                </>
                            )}
                            {isdistributorsPathExistPage && (
                                <>
                                    <h6 className="bg-[#e5e5e5] mt-[5px] rounded-md py-3.5 px-2 m-0.5 font-semibold">Distributors</h6>
                                    <Link to="/seller/distributors/View-distributors-request/">
                                        <div className="m-2 px-3 bg-white rounded-md ">
                                            <div className="flex-auto overflow-y-auto ">
                                                <div className="border-b-[1px] border-[#EBEBEB] pb-1 pt-2 ">
                                                    <div className="flex flex-row justify-between items-center space-x-2 ">
                                                        <strong className=" flex-grow text-sm font-bold text-[#002080]">
                                                            View Distributors Requests
                                                        </strong>
                                                    </div>
                                                    <div className="flex flex-row justify-between items-center space-x-2">
                                                        <p className=" mr-8 flex-grow text-sm">
                                                            All currently available orders will be viewed here
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                    <Link to="/seller/distributors/View-distributor/">
                                        <div className="m-2 px-3 bg-white rounded-md ">
                                            <div className="flex-auto overflow-y-auto ">
                                                <div className="border-b-[1px] border-[#EBEBEB] pb-1 pt-2 ">
                                                    <div className="flex flex-row justify-between items-center space-x-2 ">
                                                        <strong className=" flex-grow text-sm font-bold text-[#002080]">
                                                            View All Distributors
                                                        </strong>
                                                    </div>
                                                    <div className="flex flex-row justify-between items-center space-x-2">
                                                        <p className=" mr-8 flex-grow text-sm">
                                                            All currently available orders will be viewed here
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </>
                            )}

                            {isbuyersPathExistPage && (
                                <>
                                    <h6 className="bg-[#e5e5e5] mt-[5px] rounded-md py-3.5 px-2 m-0.5 font-semibold">Buyers</h6>

                                    <Link to="/seller/buyer/View-buyers/">
                                        <div className="m-2 px-3 bg-white rounded-md ">
                                            <div className="flex-auto overflow-y-auto ">
                                                <div className="border-b-[1px] border-[#EBEBEB] pb-1 pt-2 ">
                                                    <div className="flex flex-row justify-between items-center space-x-2 ">
                                                        <strong className=" flex-grow text-sm font-bold text-[#002080]">
                                                            View All Buyers
                                                        </strong>
                                                    </div>
                                                    <div className="flex flex-row justify-between items-center space-x-2">
                                                        <p className=" mr-8 flex-grow text-sm">
                                                            All currently available orders will be viewed here
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </>
                            )}


                            {isOrdersPathExistPage && (
                                <>
                                    <h6 className="bg-white mt-[5px] rounded-md py-3.5 px-2 m-2 font-semibold">Orders</h6>
                                    <Link to="/buyer/orders/View-Buyer-orders/">
                                        <div className="m-2 px-3 bg-white rounded-md ">
                                            <div className="flex-auto overflow-y-auto ">
                                                <div className="border-b-[1px] border-[#EBEBEB] pb-1 pt-2 ">
                                                    <div className="flex flex-row justify-between items-center space-x-2 ">
                                                        <strong className=" flex-grow text-sm font-bold text-[#002080]">
                                                            View Orders
                                                        </strong>
                                                    </div>
                                                    <div className="flex flex-row justify-between items-center space-x-2">
                                                        <p className=" mr-8 flex-grow text-sm">
                                                            All currently available orders will be viewed here
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>

                                    <Link to="/buyer/suppliers/View-all-suppliers/">
                                        <div className="m-2 px-3 bg-white rounded-md">
                                            <div className="flex-auto overflow-y-auto ">
                                                <div className="border-b-[1px] border-[#EBEBEB] pb-1 pt-2 ">
                                                    <div className="flex flex-row justify-between items-center space-x-2 ">
                                                        <strong className=" flex-grow text-sm font-bold text-[#002080]">
                                                            Place New Order
                                                        </strong>
                                                    </div>
                                                    <div className="flex flex-row justify-between items-center space-x-2">
                                                        <p className=" mr-8 flex-grow text-sm">
                                                            All currently available orders will be viewed here
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </>
                            )}


                            {isSellerOrdersPathExistPage && (
                                <>
                                    <h6 className="bg-white mt-[5px] rounded-md py-3.5 px-2 m-2 font-semibold">Orders</h6>
                                    <Link to="/seller/orders/View-Seller-orders/Placed">
                                        <div className="m-2 px-3 bg-white rounded-md ">
                                            <div className="flex-auto overflow-y-auto ">
                                                <div className="border-b-[1px] border-[#EBEBEB] pb-1 pt-2 ">
                                                    <div className="flex flex-row justify-between items-center space-x-2 ">
                                                        <strong className=" flex-grow text-sm font-bold text-[#002080]">
                                                            View Orders
                                                        </strong>
                                                    </div>
                                                    <div className="flex flex-row justify-between items-center space-x-2">
                                                        <p className=" mr-8 flex-grow text-sm">
                                                            All currently available orders will be viewed here
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </>
                            )}


                            {isUsersPathExistPage && (
                                <>
                                    <h6 className="bg-white mt-[5px] rounded-md py-3.5 px-2 m-2 font-semibold">Users</h6>
                                    <Link to="/seller/users/View-Users/">
                                        <div className="m-2 px-3 bg-white rounded-md ">
                                            <div className="flex-auto overflow-y-auto ">
                                                <div className="border-b-[1px] border-[#EBEBEB] pb-1 pt-2 ">
                                                    <div className="flex flex-row justify-between items-center space-x-2 ">
                                                        <strong className=" flex-grow text-sm font-bold text-[#002080]">
                                                            View Users
                                                        </strong>
                                                    </div>
                                                    <div className="flex flex-row justify-between items-center space-x-2">
                                                        <p className=" mr-8 flex-grow text-sm">
                                                            All currently available orders will be viewed here
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>

                                    {ActiveUser === 1 &&
                                        <Link to="/seller/users/Add-User/">
                                            <div className="m-2 px-3 bg-white rounded-md ">
                                                <div className="flex-auto overflow-y-auto ">
                                                    <div className="border-b-[1px] border-[#EBEBEB] pb-1 pt-2 ">
                                                        <div className="flex flex-row justify-between items-center space-x-2 ">
                                                            <strong className=" flex-grow text-sm font-bold text-[#002080]">
                                                                Add User
                                                            </strong>
                                                        </div>
                                                        <div className="flex flex-row justify-between items-center space-x-2">
                                                            <p className=" mr-8 flex-grow text-sm">
                                                                All currently available orders will be viewed here
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    }
                                </>
                            )}
                            {isPlanPathExistPage && (
                                <>
                                    <h6 className="bg-white mt-[5px] rounded-md py-3.5 px-2 m-2 font-semibold">Plans</h6>
                                    <Link to="/seller/plans/">
                                        <div className="m-2 px-3 bg-white rounded-md ">
                                            <div className="flex-auto overflow-y-auto ">
                                                <div className="border-b-[1px] border-[#EBEBEB] pb-1 pt-2 ">
                                                    <div className="flex flex-row justify-between items-center space-x-2 ">
                                                        <strong className=" flex-grow text-sm font-bold text-[#002080]">
                                                            View Plans
                                                        </strong>
                                                    </div>
                                                    <div className="flex flex-row justify-between items-center space-x-2">
                                                        <p className=" mr-8 flex-grow text-sm">
                                                            All currently available orders will be viewed here
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>

                                </>
                            )}
                            {isReportsPathExistPage && (
                                <>
                                    <h6 className="bg-white mt-[5px] rounded-md py-3.5 px-2 m-2 font-semibold">Plans</h6>
                                    {/* <Link to="/seller/reports/"> */}
                                    <Link to={`${(currentUserType === 'seller') ? '/seller/reports/' : '/buyer/reports/'}`}>
                                        <div className="m-2 px-3 bg-white rounded-md ">
                                            <div className="flex-auto overflow-y-auto ">
                                                <div className="border-b-[1px] border-[#EBEBEB] pb-1 pt-2 ">
                                                    <div className="flex flex-row justify-between items-center space-x-2 ">
                                                        <strong className=" flex-grow text-sm font-bold text-[#002080]">
                                                            View Reports
                                                        </strong>
                                                    </div>
                                                    <div className="flex flex-row justify-between items-center space-x-2">
                                                        <p className=" mr-8 flex-grow text-sm">
                                                            All currently available orders will be viewed here
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>

                                </>
                            )}


                            {isSettingsPathExistPage && (
                                <>
                                    <h6 className="bg-white mt-[5px] rounded-md py-3.5 px-2 m-2 font-semibold">Rules</h6>

                                    <Link to={`${(currentUserType === 'seller') ? '/seller/profile/' : '/buyer/profile/'}`}>
                                        <div className="m-2 px-3 bg-white rounded-md ">
                                            <div className="flex-auto overflow-y-auto ">
                                                <div className="border-b-[1px] border-[#EBEBEB] pb-1 pt-2 ">
                                                    <div className="flex flex-row justify-between items-center space-x-2 ">
                                                        <strong className=" flex-grow text-sm font-bold text-[#002080]">
                                                            Personal Info Setting {currentUserType}
                                                        </strong>
                                                    </div>
                                                    <div className="flex flex-row justify-between items-center space-x-2">
                                                        <p className=" mr-8 flex-grow text-sm">
                                                            All currently available orders will be viewed here
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>

                                    {hasTwo && currentUserType.toLowerCase() === 'seller' ? <Link to="/seller/EditProductAttributes/">
                                        <div className="m-2 px-3 bg-white rounded-md ">
                                            <div className="flex-auto overflow-y-auto ">
                                                <div className="border-b-[1px] border-[#EBEBEB] pb-1 pt-2 ">
                                                    <div className="flex flex-row justify-between items-center space-x-2 ">
                                                        <strong className=" flex-grow text-sm font-bold text-[#002080]">
                                                            Product Attributes Setting
                                                        </strong>
                                                    </div>
                                                    <div className="flex flex-row justify-between items-center space-x-2">
                                                        <p className=" mr-8 flex-grow text-sm">
                                                            All currently available orders will be viewed here
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Link> : null}

                                    {hasTwo && currentUserType.toLowerCase() === 'seller' ? <Link to="/seller/Badges/">
                                        <div className="m-2 px-3 bg-white rounded-md ">
                                            <div className="flex-auto overflow-y-auto ">
                                                <div className="border-b-[1px] border-[#EBEBEB] pb-1 pt-2 ">
                                                    <div className="flex flex-row justify-between items-center space-x-2 ">
                                                        <strong className=" flex-grow text-sm font-bold text-[#002080]">
                                                            Badges Setting
                                                        </strong>
                                                    </div>
                                                    <div className="flex flex-row justify-between items-center space-x-2">
                                                        <p className=" mr-8 flex-grow text-sm">
                                                            All currently available orders will be viewed here
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Link> : null}


                                    {hasTwo && currentUserType.toLowerCase() === 'seller' ? <Link to="/seller/Warehouse/">
                                        <div className="m-2 px-3 bg-white rounded-md ">
                                            <div className="flex-auto overflow-y-auto ">
                                                <div className="border-b-[1px] border-[#EBEBEB] pb-1 pt-2 ">
                                                    <div className="flex flex-row justify-between items-center space-x-2 ">
                                                        <strong className=" flex-grow text-sm font-bold text-[#002080]">
                                                            Warehouse Setting
                                                        </strong>
                                                    </div>
                                                    <div className="flex flex-row justify-between items-center space-x-2">
                                                        <p className=" mr-8 flex-grow text-sm">
                                                            All currently available orders will be viewed here
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Link> : null}


                                    <Link to="#">
                                        <div className="m-2 px-3 bg-white rounded-md ">
                                            <div className="flex-auto overflow-y-auto ">
                                                <div className="border-b-[1px] border-[#EBEBEB] pb-1 pt-2 ">
                                                    <div className="flex flex-row justify-between items-center space-x-2 ">
                                                        <strong className=" flex-grow text-sm font-bold text-[#002080]">
                                                            API Integration Setting
                                                        </strong>
                                                    </div>
                                                    <div className="flex flex-row justify-between items-center space-x-2">
                                                        <p className=" mr-8 flex-grow text-sm">
                                                            All currently available orders will be viewed here
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                    <Link to="#">
                                        <div className="m-2 px-3 bg-white rounded-md ">
                                            <div className="flex-auto overflow-y-auto ">
                                                <div className="border-b-[1px] border-[#EBEBEB] pb-1 pt-2 ">
                                                    <div className="flex flex-row justify-between items-center space-x-2 ">
                                                        <strong className=" flex-grow text-sm font-bold text-[#002080]">
                                                            Notification Setting
                                                        </strong>
                                                    </div>
                                                    <div className="flex flex-row justify-between items-center space-x-2">
                                                        <p className=" mr-8 flex-grow text-sm">
                                                            All currently available orders will be viewed here
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                    <Link to="#">
                                        <div className="m-2 px-3 bg-white rounded-md ">
                                            <div className="flex-auto overflow-y-auto ">
                                                <div className="border-b-[1px] border-[#EBEBEB] pb-1 pt-2 ">
                                                    <div className="flex flex-row justify-between items-center space-x-2 ">
                                                        <strong className=" flex-grow text-sm font-bold text-[#002080]">
                                                            Theme Setting
                                                        </strong>
                                                    </div>
                                                    <div className="flex flex-row justify-between items-center space-x-2">
                                                        <p className=" mr-8 flex-grow text-sm">
                                                            All currently available orders will be viewed here
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>

                                </>
                            )}
                        </div>
                    </div>

                    <BsArrowLeftCircleFill
                        className={`${props.issidebarOpen ? "left-[370px]" : "left-20 rotate-180 duration-800"} absolute cursor-pointer top-6 w-7 z-60 text-2xl text-font-color duration-300`}
                        onClick={props.handleSideBar}
                    />
                </div>
            </div>
        </div>

    )
}

export default Sidebar